import { useState } from 'react'
import { useIntl } from 'react-intl'
import { updateContent } from '../core/_requests'
import { toast } from 'react-toastify'
import { AddFolderModal } from '../view/AddFolderModal'
import { ContentTypes } from '../core/_constants'
import TagManager from 'react-gtm-module'
import { GTMEvent } from '../../../hooks/gtmHelpers'
import { useAuth } from '../../auth'
import { useThemeMode } from '../../../../_metronic/partials'

export function DataRoomFilesModuleSectionDropdown({
  isOpen,
  contentId,
  type,
  name,
  showRenameModal,
  setShowRenameModal,
  getAllFilesContent,
  setMenuOpen,
}: {
  isOpen: boolean
  contentId: string
  type: string
  name: string
  showRenameModal: boolean
  setShowRenameModal: any
  getAllFilesContent?: () => {}
  setMenuOpen: any
}) {
  const { formatMessage } = useIntl()
  const { mode } = useThemeMode()
  const [isRenaming, setIsRenaming] = useState<boolean>(false)
  const [newName, setNewName] = useState<string>('')
  const { currentUser, companyId } = useAuth()

  const handleRename = async (newName: string) => {
    try {
      setIsRenaming(true)
      if (contentId) {
        const {
          data: { success, errors },
        } = await updateContent(contentId, newName)
        if (success) {
          setNewName('')
          if (getAllFilesContent) {
            getAllFilesContent()
          }
          setShowRenameModal(null)
          setIsRenaming(false)
          toast.success(formatMessage({ id: 'Renamed successfully' }))
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.UpdateDataRoomFolderContentNameSuccessful,
              action: 'normal',
              metadata: {
                content_id: contentId,
                company_id: companyId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                dataroom_content_name: newName,
              },
            },
          })
        } else {
          setIsRenaming(false)
          errors.forEach((error: string) => {
            toast.error(formatMessage({ id: error }))
          })
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.UpdateDataRoomFolderContentNameFailed,
              action: 'normal',
              metadata: {
                content_id: contentId,
                company_id: companyId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                dataroom_content_name: newName,
                error: errors[0],
              },
            },
          })
        }
      }
    } catch (err) {
      setIsRenaming(false)
      console.log(err)
    }
  }

  return (
    <>
      {isOpen ? (
        <div className={`menu menu-sub menu-sub-dropdown data-room-option-dropdown${mode === 'dark' ? '-dark' : ''} show`}>
          <div
            className={`option-padding${mode === 'dark' ? '-dark' : ''}`}
            onClick={() => {
              setMenuOpen(null)
              setShowRenameModal(contentId)
            }}
          >
            <p className='mb-0 text-dark'>{formatMessage({ id: 'Rename' })}</p>
          </div>
        </div>
      ) : null}
      <AddFolderModal
        renameFolderModal={showRenameModal}
        setRenameFolderModal={() => setShowRenameModal(null)}
        onFolderRename={handleRename}
        renameLoading={isRenaming}
        folderRenameId={contentId}
        newName={newName}
        setNewName={setNewName}
        heading={
          type === ContentTypes.FILE
            ? formatMessage({ id: 'Rename File' })
            : formatMessage({ id: 'Rename Folder' })
        }
        labelText={
          type === ContentTypes.FILE
            ? formatMessage({ id: 'Please type the name of your file' })
            : formatMessage({ id: 'Please type the name of your folder' })
        }
        btnText={formatMessage({ id: 'Save Changes' })}
        showBool={false}
        prevName={name}
      />
    </>
  )
}
